export default __webpack_public_path__ + "static/media/tool_item_3.4c14ba3f.png";